import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/app/error.jsx");
